import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hierarchy-metadata-manager',
  templateUrl: './hierarchy-metadata-manager.component.html',
  styleUrls: ['./hierarchy-metadata-manager.component.scss']
})
export class HierarchyMetadataManagerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
